module.exports = __webpack_public_path__ + "img/boxes-back.617ea48a.png";